import { render, staticRenderFns } from "./OrdersForDelivery.vue?vue&type=template&id=40b9fb7f&scoped=true"
import script from "./OrdersForDelivery.vue?vue&type=script&lang=js"
export * from "./OrdersForDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9fb7f",
  null
  
)

export default component.exports